import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { FaceAnalysisVM } from '../../results-vm';
import { SkinFilterViewerComponent } from '../../../shared/components/skin-filter-viewer/skin-filter-viewer.component';

/**
 * "Facial appearance analysis" card (handoff #21) — paid-1 only, last section.
 * Reuses the SHARED app-skin-filter-viewer (the same real Perfect Corp mask
 * overlay shown in the pre-results preview) so the on-face markers match what
 * the user saw before — no duplicate decorative-dot overlay.
 */
@Component({
  selector: 'app-face-analysis-card',
  standalone: true,
  imports: [CommonModule, TranslatePipe, SkinFilterViewerComponent],
  templateUrl: './face-analysis-card.component.html',
})
export class FaceAnalysisCardComponent {
  @Input() vm: FaceAnalysisVM | null = null;
}
